import { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Alert, Box, IconButton, Typography } from "@mui/material";
import { format } from "date-fns";

import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import { useTranslation } from "@/translations";

import { useMaintenanceBanner } from "./hooks/useMaintenanceBanner";

export function MaintenanceBanner() {
  const { t } = useTranslation();
  const { language } = useLanguageContext();
  const { banner } = useMaintenanceBanner();
  const [dismissed, setDismissed] = useState(false);

  if (!banner || dismissed) {
    return null;
  }

  const message =
    banner.message ??
    t("settings.banner.maintenanceNotice", {
      startDate: format(banner.maintenanceStartUtc, "P", { locale: locales[language] }),
      startTime: format(banner.maintenanceStartUtc, "p", { locale: locales[language] }),
    });

  return (
    <Box sx={{ position: "relative", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Alert
        severity="error"
        action={
          <IconButton size="small" color="inherit" onClick={() => setDismissed(true)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        sx={{
          borderRadius: 0,
          backgroundColor: "fsw.oragen-wcag",
          color: "white",
          "& .MuiAlert-icon": { color: "white" },
        }}
      >
        <Typography variant="body2">{message}</Typography>
      </Alert>
    </Box>
  );
}
